import { render } from "./DashboardRightGroup.vue?vue&type=template&id=f1c38bfc&scoped=true"
import script from "./DashboardRightGroup.vue?vue&type=script&lang=js"
export * from "./DashboardRightGroup.vue?vue&type=script&lang=js"

import "./DashboardRightGroup.vue?vue&type=style&index=0&id=f1c38bfc&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c38bfc"]])

export default __exports__